import React, { useState } from 'react';
import toast, { Toaster } from 'react-hot-toast';

const CampusForm = (props) => {
  const BACKEND_URL = process.env.REACT_APP_BACKEND_ADDRESS;

  const [inpval, setInpval] = useState({
    fullName: "",
    email: "",
    mobileNumber: "+91",
    college: "",
    course: "",
    yearOfStudy: "",
    branchName: ""
  });

  const setval = (e) => {
    const { name, value } = e.target;
    setInpval((prev) => ({
      ...prev,
      [name]: value
    }));
  };

  const saveData = async (e) => {
    e.preventDefault();
    const { fullName, email, mobileNumber, college, course, yearOfStudy, branchName } = inpval;
    let remark= "apply for Campus Ambassador"
    // ✅ Required field check
    if (!fullName || !email || !mobileNumber || !college || !course || !yearOfStudy || !branchName) {
      toast.error('Please fill all fields');
      return;
    }

    // ✅ Phone number validation (+91 followed by 10 digits, starting with 6-9)
    const phoneRegex = /^\+91[6-9]\d{9}$/;
    if (!phoneRegex.test(mobileNumber)) {
      toast.error('Enter a valid Indian mobile number (e.g. +919876543210)');
      return;
    }

    try {
      const data = await fetch(`${BACKEND_URL}/enquiry`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          fullName, email, mobileNumber, college, course, yearOfStudy, branchName ,remark
        })
      });

      const res = await data.json();
        if(res.success){
        setInpval({
          fullName: "",
          email: "",
          mobileNumber: "+91",
          college: "",
          course: "",
          yearOfStudy: "",
          branchName: ""
        });
        toast.success('Registered successfully');   
        setTimeout(() => {
            props.closeModel() 
        }, 1000);    
        }
    } catch (error) {
      console.error("Error submitting enquiry:", error);
      toast.error("Error submitting enquiry");
    }
  };

  return (
    <>
      <div className="PopUpmodal" id="MainParentPopup">
        <div className="modalPopUpcontent">
          <div className="modal-header">
            <h4 className="modal-title" id="myModalLabel">
              Apply Now for Campus
            </h4>
            <button
              type="button"
              className="close close-button"
              data-dismiss="modal"
              aria-label="Close"
              onClick={props.closeModel}
            >
              <span aria-hidden="true">×</span>
            </button>
          </div>
          <div className="modal-body">
            <div className="w3l-contacts-12 home_form">
              <div className="contacts12-main">
                <form className="main-input">
                  <input
                    type="text"
                    placeholder="Full Name"
                    name="fullName"
                    value={inpval.fullName}
                    onChange={setval}
                    required
                  />
                  <input
                    type="email"
                    placeholder="Email"
                    name="email"
                    value={inpval.email}
                    onChange={setval}
                    required
                  />
                  <input
                    type="text"
                    placeholder="WhatsApp Number"
                    name="mobileNumber"
                    value={inpval.mobileNumber}
                    onChange={setval}
                    required
                  />
                  <input
                    type="text"
                    placeholder="College Name"
                    name="college"
                    value={inpval.college}
                    onChange={setval}
                    required
                  />
                  <input
                    type="text"
                    placeholder="Course (e.g. B.Tech, BCA)"
                    name="course"
                    value={inpval.course}
                    onChange={setval}
                    required
                  />
                  <input
                    type="text"
                    placeholder="Year of Study"
                    name="yearOfStudy"
                    value={inpval.yearOfStudy}
                    onChange={setval}
                    required
                  />
                  <input
                    type="text"
                    placeholder="Branch Name"
                    name="branchName"
                    value={inpval.branchName}
                    onChange={setval}
                    required
                  />
                  <div className="mt-3 mt-md-3">
                    <button type="submit" onClick={saveData} className="YellowBTN">
                      Submit Now
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Toaster />
    </>
  );
};

export default CampusForm;
